module.exports = parcelRequire.resolve("2B05T");